// If the data stream has a reference id with associated styles, append those styles to the data stream.
export const bindStylesToDataStreams = ({ dataStreams, styleSettings, }) => {
    return dataStreams.map(bindStyleToDataStream(styleSettings));
};
export const bindStyleToDataStream = (styleSettings) => (dataStream) => styleSettings == null || dataStream.refId == null
    ? dataStream
    : {
        ...dataStream,
        ...styleSettings[dataStream.refId],
    };
